import {
  Avatar,
  Popover,
  theme,
  Card,
  Spinner,
  Box,
  Text,
} from "@aksara-ui/react";
import React from "react";
import styled from "styled-components";
import { IconLogout } from "@aksara-ui/icons";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { logoutAction } from "redux/actions";
import { getUser } from "hooks/getUser";

const PopoverContent = styled.button`
  all: unset;
  padding: 8px;
  width: -webkit-fill-available;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  border-bottom: 1px solid ${theme.colors.grey04};
`;

const LogoutButton = styled(Box)`
  cursor: pointer;
  border-radius: 8px;
  &:hover {
    background: ${theme.colors.grey03};
  }
`;

const AvatarMenu: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = getUser();
  const { isLoading } = useSelector((state: any) => state.globalReducer);

  const handleLogout = () => {
    dispatch(logoutAction(navigate) as any);
  };

  return (
    <Popover
      trigger={
        <Avatar
          name={user ? user.name : ""}
          backgroundColor={theme.colors.blue07}
        />
      }
      placement={"bottom"}
    >
      <Card width={240} elevation={2} mb={8}>
        <PopoverContent>
          <Box
            display={"flex"}
            flexDirection={"row"}
            padding={8}
            style={{ gap: 10 }}
          >
            <Avatar
              name={user ? user.name : ""}
              backgroundColor={theme.colors.blue07}
            />
            <Box
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
            >
              <Text style={{ fontSize: 15 }}>{user ? user.name : ""}</Text>
              {/* <Text color={theme.colors.grey07} style={{ fontSize: 10 }}>
                {user ? user.email : ""}
              </Text> */}
            </Box>
          </Box>
          <Box
            marginY={8}
            borderBottom={"0.8px solid"}
            borderBottomColor={theme.colors.grey03}
          ></Box>
          <LogoutButton
            onClick={() => handleLogout()}
            paddingX={8}
            paddingY={10}
          >
            {isLoading ? (
              <Box
                display={"flex"}
                width={"100%"}
                height={"100%"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Spinner
                  label={"Loading..."}
                  size={20}
                  spinnerColor={`${theme.colors.blue07}`}
                />
              </Box>
            ) : (
              <Box display={"flex"} flexDirection={"row"} alignItems={"center"} style={{ gap: 8 }}>
                <IconLogout />
                <Text>Log Out</Text>
              </Box>
            )}
          </LogoutButton>
        </PopoverContent>
      </Card>
    </Popover>
  );
};

export default AvatarMenu;
